exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n.closed-dates-form-dialog {\n  width: 480px; }\n@media screen and (max-width: 599px) {\n    .closed-dates-form-dialog {\n      width: 100%; } }\n.closed-dates-form-dialog .mat-dialog-container {\n    padding: 0; }\n.closed-dates-form-dialog .dialog-content-wrapper {\n    max-height: 85vh;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n.closed-dates-form-dialog .primary-color-input,\n  .closed-dates-form-dialog .secondary-color-input {\n    padding: 6px 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/main/content/app/product/closed-dates/closed-dates-form.component.scss
// module id = ../../../../../src/app/main/content/app/product/closed-dates/closed-dates-form.component.scss
// module chunks = main